import { Account } from '@/domain/usecases'
import { authorizationService } from '@/data/services/authorization/authorization-service'
import { normalizeFilterOptions } from '@/data/services/authorization/authorization-service-utils'

/**
 * Loads authorization data for company manager authorizations page
 * Pre-fetches status groups and filter options (including labels)
 * Includes defensive error handling to prevent page crashes
 * Normalizes all filter options to consistent {id, name} format
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function loadCompanyManagerAuthorizations(_account: Account.Model) {
  try {
    const [statusGroups, rawFilterOptions, sharedBudget] = await Promise.all([
      authorizationService.fetchStatusGroups().catch(err => {
        console.error('❌ Failed to fetch status groups:', err)
        return []
      }),
      authorizationService.fetchFilterOptions().catch(err => {
        console.error('❌ Failed to fetch filter options:', err)
        return {
          companies: [],
          departments: [],
          jobs: [],
          status: [],
          partners: [],
          labels: [],
          accountTypes: []
        }
      }),
      authorizationService.fetchCompanySharedBudget().catch(err => {
        console.error('❌ Failed to fetch shared budget:', err)
        return 0
      })
    ])

    // Normaliza todas as opções de filtro para o formato padronizado {id, name}
    const filterOptions = {
      companies: normalizeFilterOptions(rawFilterOptions.companies || []),
      departments: normalizeFilterOptions(rawFilterOptions.departments || []),
      jobs: normalizeFilterOptions(rawFilterOptions.jobs || []),
      status: normalizeFilterOptions(
        (rawFilterOptions.status || []) as unknown as Array<{ [key: string]: unknown }>
      ),
      partners: normalizeFilterOptions(rawFilterOptions.partners || []),
      labels: normalizeFilterOptions(
        (rawFilterOptions.labels || []) as unknown as Array<{ [key: string]: unknown }>
      ),
      accountTypes: rawFilterOptions.accountTypes || []
    }

    return {
      statusGroups,
      filterOptions,
      sharedBudget
    }
  } catch (error) {
    console.error('Critical error loading authorization data:', error)
    // Return safe defaults to prevent complete page failure
    return {
      statusGroups: [],
      filterOptions: {
        companies: [],
        departments: [],
        jobs: [],
        status: [],
        partners: [],
        labels: [],
        accountTypes: []
      },
      sharedBudget: 0
    }
  }
}
